import React, {useState} from 'react';
import {Col, Menu, Modal, Tooltip} from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import PropTypes from 'prop-types';
import {useTranslation} from "react-i18next";
import {useTableMenuContext} from "../../list/components/TableMenu";
import {font_icon} from "../../column";

const DG_Menu_Delete = ({hint, ...props}) => {

    const id = props?.id

    const {t} = useTranslation()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const {mode} = useTableMenuContext()


    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        props.onOk(id)

    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>

            {
                mode === "setting" ?
                    <Col onClick={() => {
                        Modal.confirm({
                            onOk: () => {
                                return props.onOk(id)
                            },
                            content:
                                <p>{props.content ? props.content : t("common.message.deleteAsk")}</p>,
                            okText: props?.okText ? props?.okText : t("common.btn.delete"),
                            cancelText: t("tnp.button.cancelText"),
                            maskClosable: false,
                            icon: null,
                        })
                    }} className={"cursor-pointer"}>
                        <Tooltip title={t("tnp.button.delete") || hint}>
                            <DeleteOutlined className={"text-lg text-[#344054] absolute top-1/2 cursor-pointer"}
                                            style={{transform: "translateY(-50%)", fontSize: font_icon}}/>
                        </Tooltip>

                    </Col>
                    :
                    <Menu.Item {...props} className={'text-red-600'} onClick={showModal}
                               icon={<DeleteOutlined
                                   style={{fontSize: font_icon}}
                                   title={props?.title ? props?.title : t("tnp.button.delete")}
                                   className={props?.iconClassName}/>}>{t("common.delete")}</Menu.Item>}
            <Modal
                visible={isModalVisible}
                onCancel={handleCancel}
                okText={t("common.btn.delete")}
                cancelText={<strong style={{color: "rgba(236,41,41,0.9)"}}>{t("common.btn.cancel")}</strong>}
                destroyOnClose={true}
                {...props}
                onOk={handleOk}
            >
                <p>{props.content ? props.content : t("common.message.deleteAsk")}</p>
            </Modal>
        </>
    );
};

DG_Menu_Delete.propTypes = {
    onOk: PropTypes.func.isRequired,

};

export default DG_Menu_Delete;
